import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Skeleton,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SingleLineTextInputSkeleton } from '@/components/SingleLineTextInputSkeleton'

const seleniumPrefix = 'project-create-or-edit-pending-component'

export const ProjectCreateOrEditPendingComponent: React.FC<{
    title: string
}> = ({ title }) => {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={title} />

            <CardContent>
                <SingleLineTextInputSkeleton />

                <Skeleton
                    height={120}
                    sx={{ marginTop: 2, marginBottom: 1 }}
                    style={{ transform: 'unset' }}
                />

                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-back`}
                >
                    {t('common.back')}
                </Button>
                <Button
                    variant={'outlined'}
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-save`}
                >
                    {t('common.save')}
                </Button>
            </CardActions>
        </Card>
    )
}
